export const Messange = ({ text }) => {
    return <p>{text}</p>;
}